/* ORTTU · native cart · shared cart state for the Early Black cart bar, PDP module,
   free-shipping bar and Insiders upsell.
   window.EBCart.count(cart) is THE piece counter: the PDP module (early-black-pdp.js) and the cart bar both use it.
   Skips the service products below and any gift card line. Insiders Club (8638054236323) DOES count. */
(function () {
  if (window.EBCart) { window.EBCart.apply(); return; }
  var SKIP = { 9055792922787: 1, 9031978025123: 1, 8937665822883: 1, 8027879211171: 1 };
  var MEMBERSHIP_PID = 8638054236323;
  var COPY = [
    'Add 2 pieces to unlock 15% off with EARLYBLACK',
    'Add 1 more piece for 15% off',
    '15% unlocked. Add 1 more piece for 20% off',
    '20% unlocked. Add 1 more piece for 25% off',
    '25% unlocked, the top tier. Enter EARLYBLACK at checkout'
  ];
  var subs = [], last = null, pending = null;
  var origFetch = window.fetch.bind(window);

  function skipped(it) { return !!(SKIP[it.product_id] || it.gift_card); }
  function count(cart) {
    var n = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (!skipped(items[i])) n += items[i].quantity || 0;
    return n;
  }
  /* subtotal of counted lines, excluding the membership itself (basis for the Insiders comparison) */
  function memberBase(cart) {
    var s = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (skipped(it) || it.product_id === MEMBERSHIP_PID) continue;
      s += it.final_line_price || 0;
    }
    return s;
  }
  function hasMembership(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].product_id === MEMBERSHIP_PID) return true;
    return false;
  }
  function rate() { var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 ? r : 1; }
  /* Money without the currency suffix, mirroring snippets/nc-money.liquid. The format is learned from a
     Liquid-rendered sample (123456789 cents) on the free-shipping bar, so JS and Liquid always agree. */
  var fmt = null;
  function moneyFmt() {
    if (fmt) return fmt;
    var el = document.querySelector('[data-nc-money-sample]');
    var smp = el && el.getAttribute('data-nc-money-sample');
    var m = smp && smp.match(/\d[\d.,'\s\u00a0\u202f]*\d/);
    if (!m) return null;
    var num = m[0], digits = num.replace(/\D/g, '');
    fmt = {
      pre: smp.slice(0, m.index), post: smp.slice(m.index + num.length),
      dec: digits.length === 9 ? num.charAt(num.length - 3) : '',
      grp: /\d/.test(num.charAt(1)) ? '' : num.charAt(1)
    };
    return fmt;
  }
  function money(cents, cur) {
    cur = cur || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    cents = Math.round(cents);
    var f = moneyFmt() || (cur === 'USD' ? { pre: '$', post: '', dec: '.', grp: ',' } : { pre: '', post: ' ' + cur, dec: '.', grp: ',' });
    var whole = String(Math.floor(Math.abs(cents) / 100)), frac = ('0' + Math.abs(cents) % 100).slice(-2);
    if (!f.dec) { whole = String(Math.round(Math.abs(cents) / 100)); frac = '00'; }
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, f.grp);
    return (cents < 0 ? '-' : '') + f.pre + whole + (frac !== '00' && f.dec ? f.dec + frac : '') + f.post;
  }

  /* Global-e-implied USD -> presentment rate (Global-e prices carry duties/uplift, so Shopify.currency.rate
     under-states them: GEL 2.67 vs ~3.48). Ratio of a presentment price to the same variant's USD price,
     fetched cookie-less (= US / USD storefront). Cached per country+currency for the session. */
  var geRates = {}, geBusy = {};
  function rateKey(cart) { return (window.Shopify && Shopify.country || '') + ':' + (cart.currency || ''); }
  function geRate(cart) {
    var k = rateKey(cart);
    if (geRates[k]) return geRates[k];
    try { var c = +sessionStorage.getItem('nc-ge-rate:' + k); if (c > 0) return (geRates[k] = c); } catch (e) {}
    return null;
  }
  function loadGeRate(cart) {
    var k = rateKey(cart);
    if (geRates[k] || geBusy[k]) return geBusy[k] || Promise.resolve(geRates[k]);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var it = null, items = cart.items || [];
    for (var i = 0; i < items.length; i++) if (!skipped(items[i]) && !items[i].selling_plan_allocation && items[i].original_price > 0) { it = items[i]; break; }
    var handle = it ? it.handle : 'stefano-shirt-1';
    var usdP = origFetch('/products/' + handle + '.js?country=US&currency=USD', { credentials: 'omit' }).then(function (r) { return r.json(); });
    var locP = it ? Promise.resolve(null) : origFetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    geBusy[k] = Promise.all([usdP, locP]).then(function (res) {
      var usd = res[0], loc = res[1], vid = it ? it.variant_id : (usd.variants && usd.variants[0] && usd.variants[0].id);
      var pick = function (p) { var v = (p.variants || []).filter(function (x) { return x.id === vid; })[0]; return v ? v.price : 0; };
      var usdPrice = pick(usd), locPrice = it ? it.original_price : pick(loc);
      var r = usdPrice > 0 && locPrice > 0 ? locPrice / usdPrice : 0;
      if (!(r > 0)) throw new Error('no rate');
      geRates[k] = r; try { sessionStorage.setItem('nc-ge-rate:' + k, String(r)); } catch (e) {}
      return r;
    }).catch(function () { geRates[k] = rate(); return geRates[k]; })
      .then(function (r) { delete geBusy[k]; return r; });
    return geBusy[k];
  }

  /* ---------- Early Black cart bar ---------- */
  function paintBar(root, n) {
    root.setAttribute('data-ebc-count', n);
    var m = root.querySelector('[data-ebc-msg]'), t = COPY[Math.min(n, 4)]; if (m && m.textContent !== t) m.textContent = t;
    var f = root.querySelector('[data-ebc-fill]'); if (f) f.style.width = (Math.min(n, 4) / 4 * 100) + '%';
    var mk = root.querySelectorAll('[data-ebc-mark]');
    for (var i = 0; i < mk.length; i++) mk[i].classList.toggle('is-on', n >= +mk[i].getAttribute('data-ebc-mark'));
  }
  /* ---------- free shipping ----------
     Source: metaobject free_shipping_threshold via snippets/free-shipping-threshold.liquid, which renders
       - the cart bar root [data-ncship] (data-ncship-mode / data-ncship-threshold), and
       - a page-level blob <script data-fst-json> (cart drawer snippet, every page) for the PDP text, badge, announcement.
     mode "local": threshold is in the cart's own currency -> used directly;
     mode "usd"/"convert": it is USD cents -> converted at the Global-e-implied rate unless the cart is in USD.
     Override hook: window.NC_FREESHIP_MAP = { GE: { amount: 700, currency: 'GEL' } } (testing only). */
  function effThreshold(mode, thr, cc, cart) {
    var cur = cart.currency || 'USD';
    thr = +thr || 20000;
    var map = window.NC_FREESHIP_MAP;
    if (map && cc && map[cc] && map[cc].amount > 0) {
      var o = map[cc]; thr = Math.round(o.amount * 100);
      mode = (String(o.currency || 'USD').toUpperCase() === cur) ? 'local' : 'usd';
    }
    if (mode === 'local' || cur === 'USD') return thr;
    var r = geRate(cart);
    if (!r) { loadGeRate(cart).then(function () { apply(); }); return null; }
    return Math.round(thr * r / 100) * 100; /* whole currency units, e.g. 696 GEL */
  }
  function shipThreshold(root, cart) {
    return effThreshold(root.getAttribute('data-ncship-mode') || 'usd', root.getAttribute('data-ncship-threshold'),
      root.getAttribute('data-ncship-country') || (window.Shopify && Shopify.country), cart);
  }
  var fstCache;
  function fst() {
    if (fstCache !== undefined) return fstCache;
    var el = document.querySelector('script[data-fst-json]');
    try { fstCache = el ? JSON.parse(el.textContent) : null; } catch (e) { fstCache = null; }
    return fstCache;
  }
  /* PDP / announcement amount spans (unlisted countries, non-USD cart) + the "Free Shipping Unlocked" badge */
  function paintFst(cart) {
    var d = fst(); if (!d) return;
    var thr = effThreshold(d.mode === 'local' ? 'local' : 'usd', d.cents, d.country, cart);
    if (thr == null) return;
    var cur = cart.currency || 'USD', sp = document.querySelectorAll('[data-fst-amount]');
    for (var i = 0; i < sp.length; i++) {
      var t = money(thr, cur); if (sp[i].textContent !== t) sp[i].textContent = t;
      sp[i].style.visibility = ''; sp[i].setAttribute('data-fst-painted', thr);
    }
    var total = cart.total_price || 0;
    window.dispatchEvent(new CustomEvent('nc-freeship', { detail: { threshold: thr, total: total, unlocked: total > 0 && total >= thr, currency: cur } }));
  }
  function paintShip(root, cart) {
    var cur = cart.currency || 'USD';
    var thr = shipThreshold(root, cart);
    if (thr == null) return; /* stays data-pending until the rate arrives */
    var total = cart.total_price || 0, left = Math.max(0, thr - total);
    var msg = root.querySelector('[data-ncship-msg]'), fill = root.querySelector('[data-ncship-fill]');
    root.classList.toggle('is-unlocked', left <= 0);
    root.setAttribute('data-ncship-effective', thr);
    if (msg) {
      var want = left <= 0 ? "You've unlocked Free Shipping" : 'You are ' + money(left, cur) + ' away from Free Shipping';
      if (msg.textContent === want) {}
      else if (left <= 0) msg.textContent = want;
      else { msg.innerHTML = ''; msg.appendChild(document.createTextNode('You are ')); var b = document.createElement('b'); b.textContent = money(left, cur); msg.appendChild(b); msg.appendChild(document.createTextNode(' away from Free Shipping')); }
    }
    if (fill) fill.style.width = Math.min(100, thr ? total / thr * 100 : 0) + '%';
    root.removeAttribute('data-pending');
  }
  /* ---------- Insiders upsell ---------- */
  function paintInsiders(root, cart) {
    if (hasMembership(cart) || count(cart) === 0) { root.hidden = true; return; }
    root.hidden = false;
    var cur = cart.currency || 'USD', base = memberBase(cart);
    var set = function (k, v) { var e = root.querySelector('[data-nci="' + k + '"]'); if (e && e.textContent !== v) e.textContent = v; };
    set('member-pay', money(Math.round(base * 0.9), cur));
    set('nonmember-pay', money(base, cur));
    set('member-credit', money(Math.round(base * 0.2), cur));
  }

  function apply(cart) {
    cart = cart || last; if (!cart) return;
    var n = count(cart), i, r;
    r = document.querySelectorAll('[data-ebc]'); for (i = 0; i < r.length; i++) paintBar(r[i], n);
    r = document.querySelectorAll('[data-ncship]'); for (i = 0; i < r.length; i++) paintShip(r[i], cart);
    r = document.querySelectorAll('[data-nci-card]'); for (i = 0; i < r.length; i++) paintInsiders(r[i], cart);
    paintFst(cart);
    for (i = 0; i < subs.length; i++) { try { subs[i](n, cart); } catch (e) {} }
  }
  function refresh() {
    if (pending) return pending;
    var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js';
    pending = origFetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var first = !last; last = c; apply(c);
        /* the theme's header bubble starts at 0 until a cart event; seed it once on load */
        if (first) window.dispatchEvent(new CustomEvent('cart-count-updated', { detail: c.item_count }));
        return c;
      })
      .catch(function () {})
      .then(function (c) { pending = null; return c; });
    return pending;
  }
  function soon() { setTimeout(refresh, 150); setTimeout(refresh, 900); }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (CART_RE.test(u)) p.then(soon, soon);
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', soon);
    return xo.apply(this, arguments);
  };
  ['added-to-cart', 'update-cart', 'cart:updated', 'cart:refresh', 'ajaxProduct:added'].forEach(function (e) {
    window.addEventListener(e, soon);
  });
  window.addEventListener('focus', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });

  /* Insiders ADD TO BAG: membership variant + its required Inveterate selling plan */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('[data-nci-add]');
    if (!b) return;
    ev.preventDefault();
    if (b.disabled) return;
    b.disabled = true; b.classList.add('is-loading');
    var item = { id: +b.getAttribute('data-variant'), quantity: 1 };
    var plan = b.getAttribute('data-selling-plan'); if (plan) item.selling_plan = +plan;
    origFetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json(); })
      .then(function () { window.dispatchEvent(new CustomEvent('update-cart')); soon(); })
      .catch(function (e) { console.error('Insiders add failed', e); })
      .then(function () { b.disabled = false; b.classList.remove('is-loading'); });
  });

  /* the theme swaps drawer / cart-page HTML on every change: repaint + re-register countdowns */
  var moTimer = null;
  var WATCH = '[data-ebc],[data-ncship],[data-nci-card],[data-eb-countdown],[data-fst-amount]';
  function relevant(recs) {
    for (var i = 0; i < recs.length; i++) {
      var a = recs[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && ((n.matches && n.matches(WATCH)) || (n.querySelector && n.querySelector(WATCH)))) return true;
      }
    }
    return false;
  }
  new MutationObserver(function (recs) {
    if (moTimer || !relevant(recs)) return;
    moTimer = setTimeout(function () {
      moTimer = null;
      if (window.__ebCountdown) window.__ebCountdown.scan();
      apply();
    }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.EBCart = {
    SKIP: SKIP, MEMBERSHIP_PID: MEMBERSHIP_PID, COPY: COPY,
    count: count, memberBase: memberBase, hasMembership: hasMembership, money: money,
    refresh: refresh, soon: soon, freeShipping: fst, geRate: function () { return last && geRate(last); }, apply: function () { apply(); },
    last: function () { return last; },
    subscribe: function (fn) { subs.push(fn); if (last) { try { fn(count(last), last); } catch (e) {} } }
  };
  refresh();
})();
